import { computed } from 'vue'
import { useStore } from 'vuex'
import { setSnackbar } from 'best-modules/plugins'

export function useCan() {
  const store = useStore()

  function callbackHandler(hasAccess: boolean, cb?: () => any): any {
    if (typeof cb !== 'function') return

    return hasAccess
      ? cb()
      : setSnackbar({ text: 'Немає доступу', color: 'warning' })
  }

  function can(permission: string, cb?: () => any): boolean {
    callbackHandler(store.getters['user/can'](permission), cb)

    return store.getters['user/can'](permission)
  }

  function canAny(permissions: string[], cb?: () => any): boolean {
    callbackHandler(store.getters['user/canAny'](permissions), cb)

    return store.getters['user/canAny'](permissions)
  }

  const permissions = computed<string[]>(
    () => store.getters['user/permissions']
  )

  return { can, canAny, permissions }
}
